import * as React from 'react';
import { Box, ThemeUICSSObject } from '@apia/theme';

export interface IAsidePanel {
  title?: string;
  toolTip?: string;
  children: React.ReactNode;
  columns?: number;
  spacer?: boolean;
  className?: string;
}

export const AsidePanel = ({
  title,
  toolTip,
  children,
  columns = 2,
  spacer,
  className,
}: IAsidePanel) => {
  const contentSx: ThemeUICSSObject = React.useMemo(
    () => ({
      gridTemplateColumns: `${Array(columns).fill('1fr').join(' ')} `,
    }),
    [columns],
  );

  return (
    <Box as="fieldset" className={`asidePanel ${className ?? ''}`}>
      {title && <legend title={toolTip}>{title}</legend>}
      {spacer !== false && <Box className="spacer" />}
      <Box className="asidePanel__content" sx={contentSx}>
        {children}
      </Box>
    </Box>
  );
};
